import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import Panel from "../../../UIX/Panel"
import { __ } from "src/libs/utilities"
import { PanelData } from "../../../UIX/interface"
import { CardsContent } from "src/modules/pe-landing-module/data/interfaces"
import CardsFieldsPanelContent from "./CardsFieldsPanelContent"

/* Protopia Ecosystem component */
export interface ICardFieldPanelProps {
   
}
const CardFieldPanel = (props: ICardFieldPanelProps): JSX.Element => {
    const { cardFieldsPositions }	= useLandingStore((state: ILandingStore) => state) 

    const onPosition = ( x:number, y: number, w: number, h: number ) => {
        useLandingStore.setState({cardFieldsPositions:{ x, y, w, h }})
    }
    return <Panel 
            x={ cardFieldsPositions?.x }
            y={ cardFieldsPositions?.y }
            w={ cardFieldsPositions?.w }
            h={ cardFieldsPositions?.h }
            isOpen={true}
            id="landing-card-field"
            onPosition={onPosition}
            data={{
                title: __(`Card template's Fields`),
                icon: "/assets/img/landing/rows.svg",
                data: <CardsFieldsPanelContent {...props} />
            } as PanelData}
        />
}
export default CardFieldPanel

